/**
 * AT packet required-field validation (matches backend atPacketBusinessRules).
 * Required: client_id, at_doctor_provider_id, status_id, start_date;
 * on create also request_name.
 * insurance_type_id is legacy-only and no longer required.
 */

const LABELS = {
  client_id: 'Client',
  request_name: 'Request name',
  at_doctor_provider_id: 'AT doctor',
  status_id: 'Status',
  start_date: 'Start date',
};

const REQUIRED_UPDATE = ['client_id', 'at_doctor_provider_id', 'status_id', 'start_date'];
const REQUIRED_CREATE = ['request_name', ...REQUIRED_UPDATE];

function isEmpty(v) {
  return v === undefined || v === null || v === '';
}

/**
 * @param {object} data - Form/payload (snake_case)
 * @param {boolean} isCreate
 * @returns {{ valid: boolean, errors: string[] }}
 */
export function validateAtPacketRequired(data, isCreate) {
  const required = isCreate ? REQUIRED_CREATE : REQUIRED_UPDATE;
  const errors = [];
  for (const key of required) {
    const value = data[key];
    if (isEmpty(value) || (typeof value === 'string' && value.trim() === '')) {
      errors.push(LABELS[key] || key);
    }
  }
  return { valid: errors.length === 0, errors };
}
